import { createUniqueId } from 'solid-js'

export function RealTreeIcon() {
  // Minted per instance, so copies of one icon never resolve url(#…) to
  // each other's defs
  const id = createUniqueId()
  const paint0 = `real-tree-icon-${id}-paint0`
  const paint1 = `real-tree-icon-${id}-paint1`
  const paint2 = `real-tree-icon-${id}-paint2`
  const paint3 = `real-tree-icon-${id}-paint3`
  const paint4 = `real-tree-icon-${id}-paint4`
  const clip0 = `real-tree-icon-${id}-clip0`

  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g clip-path={`url(#${clip0})`}>
        <path
          d="M23 41.6501C12.71 41.6501 4.35001 33.2801 4.35001 23.0001C4.35001 12.7201 12.71 4.3501 23 4.3501C33.29 4.3501 41.65 12.7201 41.65 23.0001C41.65 33.2801 33.28 41.6501 23 41.6501Z"
          fill={`url(#${paint0})`}
        />
        <path
          d="M23 37.6199C31.08 37.6199 37.62 31.0699 37.62 22.9999C37.62 14.9299 31.07 8.37988 23 8.37988C14.93 8.37988 8.38 14.9299 8.38 22.9999C8.38 31.0699 14.93 37.6199 23 37.6199Z"
          fill={`url(#${paint1})`}
        />
        <path
          opacity="0.78"
          d="M20.9882 20.0305C21.7043 20.0305 22.3545 20.4171 22.7126 20.9259C22.8162 21.0683 22.9952 21.3634 22.9952 21.3634C22.9952 21.3634 23.2025 21.0581 23.3062 20.9259C23.6737 20.407 24.3144 20.0102 24.9835 20C26.0859 20 26.9905 20.8852 26.9999 22.0043C27.0094 24.1918 24.7856 26.013 23.6643 26.7964C23.2779 27.061 22.7879 27.0711 22.3922 26.8066C21.2614 26.0435 19.0094 24.2529 19 22.0654C19 20.9462 19.8763 20.0305 20.9882 20.0203V20.0305Z"
          fill="#A2FF31"
        />
        <path
          d="M15.36 12.97C15.36 14.73 13.94 16.15 12.19 16.15C11.52 16.15 10.9 15.94 10.39 15.59C11.47 13.76 12.93 12.2 14.66 11C15.09 11.54 15.35 12.22 15.35 12.97H15.36Z"
          fill={`url(#${paint2})`}
        />
        <path
          d="M26.02 37.31C25.05 37.52 24.03 37.63 23 37.63C16.95 37.63 11.78 33.97 9.54001 28.75H14.14C16.01 28.75 17.6 30.02 18.06 31.74H20.13C23.28 31.74 25.85 34.21 26 37.32L26.02 37.31Z"
          fill={`url(#${paint3})`}
        />
        <path
          d="M37.47 20.9199C34.04 20.6599 31.26 18.0499 30.78 14.6899H28.14C25.69 14.6899 23.72 12.7199 23.72 10.2899C23.72 9.61993 23.87 8.98993 24.14 8.42993C31 8.94993 36.51 14.1999 37.47 20.9199Z"
          fill={`url(#${paint4})`}
        />
        <path
          d="M40.9559 33.4902L41.6618 32.7843C43.4461 31 43.4461 28.1078 41.6618 26.3333C40.799 25.4706 39.652 25 38.4363 25C37.2206 25 36.0735 25.4706 35.2108 26.3333L34.5049 27.0392L33.799 26.3333C32.9363 25.4706 31.7892 25 30.5735 25C29.3578 25 28.201 25.4608 27.3382 26.3235C25.5637 28.1078 25.5637 31 27.3382 32.7843L28.0441 33.4902L27.3382 34.1961C25.5539 35.9804 25.5539 38.8726 27.3382 40.6471C28.201 41.5098 29.348 41.9804 30.5637 41.9804C31.7794 41.9804 32.9265 41.5098 33.7892 40.6471L34.4951 39.9412L35.201 40.6471C36.0637 41.5098 37.2108 41.9804 38.4265 41.9804C39.6422 41.9804 40.7892 41.5098 41.652 40.6471C43.4363 38.8627 43.4363 35.9706 41.652 34.1961L40.9461 33.4902H40.9559Z"
          fill="white"
        />
        <path
          d="M37.4362 33.4903L39.9068 31.0197C40.7206 30.206 40.7206 28.8922 39.9068 28.0883C39.0931 27.2844 37.7794 27.2746 36.9755 28.0883L34.5049 30.5589L32.0343 28.0883C31.2206 27.2746 29.9068 27.2746 29.1029 28.0883C28.299 28.902 28.2892 30.2158 29.1029 31.0197L31.5735 33.4903L29.1029 35.9609C28.2892 36.7746 28.2892 38.0883 29.1029 38.8922C29.5049 39.2942 30.0343 39.5001 30.5735 39.5001C31.1127 39.5001 31.6323 39.2942 32.0441 38.8922L34.5147 36.4217L36.9853 38.8922C37.3872 39.2942 37.9166 39.5001 38.4558 39.5001C38.9951 39.5001 39.5147 39.2942 39.9264 38.8922C40.7402 38.0785 40.7402 36.7648 39.9264 35.9609L37.4558 33.4903H37.4362Z"
          fill="#FF3F6F"
        />
      </g>
      <defs>
        <linearGradient
          id={paint0}
          x1="23"
          y1="42"
          x2="23"
          y2="4"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00FF00" />
          <stop offset="1" stop-color="#99FF00" />
        </linearGradient>
        <linearGradient
          id={paint1}
          x1="22.9991"
          y1="38"
          x2="22.9991"
          y2="-2.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#005B52" />
          <stop offset="1" stop-color="#00DF00" />
        </linearGradient>
        <linearGradient
          id={paint2}
          x1="17.35"
          y1="17.47"
          x2="11.76"
          y2="12.61"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#04541A" />
          <stop offset="1" stop-color="#027E14" />
        </linearGradient>
        <linearGradient
          id={paint3}
          x1="13"
          y1="40.5"
          x2="12.5009"
          y2="25.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.03" stop-color="#033415" />
          <stop offset="1" stop-color="#025715" />
        </linearGradient>
        <linearGradient
          id={paint4}
          x1="43.28"
          y1="26.4299"
          x2="22.06"
          y2="6.25993"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.03" stop-color="#04531A" />
          <stop offset="1" stop-color="#027D15" />
        </linearGradient>
        <clipPath id={clip0}>
          <rect width="46" height="46" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
